export default class Cliente {
    constructor(usuarioActual, cuil, nroCuenta, fisicaJuridica) {
        this.usuarioActual = usuarioActual;
        this.cuil = cuil;
        this.nroCuenta = nroCuenta;
        this.FisicaJuridica = fisicaJuridica;
    }
}



// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/SeleccionCuentas/components/Cliente.js